var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.342773,
    width: 17.3137,
    height: 17.3137,
    rx: 8.65685,
    fill: "#2A9F47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4853 11.8284C11.6416 11.6721 11.644 11.4139 11.4877 11.2575L9.23012 9L11.4877 6.74247C11.644 6.58612 11.644 6.33029 11.4877 6.17394C11.3313 6.0176 11.0755 6.0176 10.9191 6.17394L8.66159 8.43147L6.39932 6.1692C6.24298 6.01286 5.98714 6.01286 5.82843 6.17157C5.66971 6.33029 5.67208 6.58376 5.82843 6.7401L8.08833 9L5.82843 11.2599C5.67208 11.4162 5.67208 11.6721 5.82843 11.8284C5.98477 11.9848 6.24061 11.9848 6.39696 11.8284L8.65685 9.56853L10.9144 11.8261C11.0707 11.9824 11.3266 11.9824 11.4829 11.8261L11.4853 11.8284Z",
    fill: "#0B2812"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.2c8249ddc8a5c0b650d34d17a40c53e3.svg";
export { ForwardRef as ReactComponent };